import { Injectable } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';

import { WorkloadIndicator } from '../modules/shared/services/progress-bar.service';

const DELAY = 100;

@Injectable({
  providedIn: 'root',
})
export class ProgressLoadingPageService extends WorkloadIndicator {
  private startTimeout: number;

  constructor(private router: Router) {
    super();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        clearTimeout(this.startTimeout);
        this.startTimeout = setTimeout(() => this.start(), DELAY);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        clearTimeout(this.startTimeout);
        this.stop();
      }
    });
  }
}
